var _excluded = ["children", "className", "href", "onClick"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useMemo } from 'react';
import classnames from 'classnames';
import Link from "../Link";
import StyledErrorSummaryItem from "./styled";
/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/error-summary)
 **/
var ErrorSummaryItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    href = _ref.href,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classNames = useMemo(function () {
    return classnames('csl-error-summary-item', className);
  }, [className]);
  return /*#__PURE__*/React.createElement(StyledErrorSummaryItem, _extends({}, rest, {
    className: classNames,
    ref: ref
  }), /*#__PURE__*/React.createElement(Link, {
    className: "csl-error-summary-item__link",
    href: href,
    onClick: onClick
  }, children));
});
ErrorSummaryItem.displayName = 'ErrorSummaryItem';
export default ErrorSummaryItem;